import { useEffect, useState } from 'react'
import { CommonConstant, CompetitionService, VideosService } from 'utility'

export const GetVideosList = defaultSort => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [total, setTotal] = useState(0)
  const [filter, setFilter] = useState({
    limit: 9,
    page: 0,
    sort: defaultSort || 'newest',
  })

  const fetchData = async () => {
    setLoading(true)
    try {
      const result = await VideosService.get(filter)
      setTotal(result.total || 0)
      setData(result.list || [])
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filter])

  const updateFilter = (key, value) => {
    setFilter(prevFilters => {
      if (typeof key === 'object') {
        return { ...prevFilters, sort: undefined, ...key }
      }
      return { ...prevFilters, [key]: value }
    })
  }

  const pageChanged = page => {
    setFilter(prev => ({
      ...prev,
      page,
    }))
  }

  const pageSizeChanged = limit => {
    setFilter(prev => ({
      ...prev,
      page: 0,
      limit,
    }))
  }

  const refetch = () => {
    fetchData()
  }

  return {
    data,
    setData,
    loading,
    error,
    total,
    setTotal,
    updateFilter,
    filter,
    pageChanged,
    pageSizeChanged,
    refetch,
  }
}
export const GetFlaggedVideosList = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [total, setTotal] = useState(0)
  const [filter, setFilter] = useState({
    page: 0,
    limit: 10,
    sort: 'newest',
    flagReasons: [],
    dateRange: undefined,
  })

  const fetchData = async () => {
    setLoading(true)
    try {
      const result = await VideosService.flagged(filter)
      setTotal(result.total || 0)
      setData(result.list || [])
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filter])

  const updateFilter = (key, value) => {
    setFilter(prevFilters => {
      if (typeof key === 'object') {
        const result = key?.flagReasons.join(', ')
        return { ...prevFilters, ...key, sort: undefined, flagReasons: result }
      }
      return { ...prevFilters, [key]: value }
    })
  }

  const pageChanged = page => {
    setFilter({
      ...filter,
      page,
    })
  }

  const pageSizeChanged = limit => {
    setFilter(prev => ({
      ...prev,
      page: 0,
      limit,
    }))
  }

  const refetch = () => {
    fetchData()
  }

  return {
    data,
    setData,
    loading,
    error,
    total,
    setTotal,
    updateFilter,
    filter,
    pageChanged,
    pageSizeChanged,
    refetch,
  }
}
export const GetDeletedVideosList = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [total, setTotal] = useState(0)
  const [filter, setFilter] = useState({
    page: 0,
    limit: 12,
    sort: 'newest',
    deletionReasons: [],
    dateRange: undefined,
  })

  const fetchData = async () => {
    setLoading(true)
    try {
      const result = await VideosService.deleted(filter)
      setTotal(result.total || 0)
      setData(result.list || [])
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filter])

  const updateFilter = (key, value) => {
    setFilter(prevFilters => {
      if (typeof key === 'object') {
        const result = key?.deletionReasons?.join(', ') || []
        return {
          ...prevFilters,
          ...key,
          sort: undefined,
          deletionReasons: result,
        }
      }
      return { ...prevFilters, [key]: value }
    })
  }

  const pageChanged = page => {
    setFilter({
      ...filter,
      page,
    })
  }
  const pageSizeChanged = limit => {
    setFilter(prev => ({
      ...prev,
      page: 0,
      limit,
    }))
  }
  const refetch = () => {
    fetchData()
  }

  return {
    data,
    setData,
    loading,
    error,
    total,
    updateFilter,
    filter,
    pageChanged,
    pageSizeChanged,
    refetch,
  }
}
export const useGetDashboardData = () => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [filter, setFilter] = useState({})

  const fetchData = async () => {
    setLoading(true)
    try {
      const result = await VideosService.getDashBoardData(filter)
      const result1 = await CompetitionService.getDashBoardLiveRound(filter)
      setData({ ...result?.data, liveRoundData: result1 })
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filter])

  const updateFilter = (key, value) => {
    setFilter(prev => {
      if (typeof key === 'object') {
        return { ...prev, ...key }
      }
      return { ...prev, [key]: value }
    })
  }

  const refetch = () => {
    fetchData()
  }

  return {
    data,
    setData,
    loading,
    error,
    filter,
    updateFilter,
    refetch,
  }
}
export const GetVideosById = Id => {
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchData = async id => {
    setLoading(true)
    try {
      const result = await CompetitionService.getById(id)
      setData(result)
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (Id) {
      fetchData(Id)
    }
  }, [Id])

  return {
    data,
    setData,
    loading,
    error,
    fetchData,
  }
}

export const GetVideosByUserId = id => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [filter, setFilter] = useState({
    limit: 9,
    page: 0,
  })
  const [prevDataLength, setPrevDataLength] = useState(0)
  const [hasMore, setHasMore] = useState(true)

  const fetchData = async (isLoadMore = false) => {
    if (!hasMore) return
    setLoading(true)

    try {
      const result = await VideosService.getVideoByUserId(id, filter)
      setData(prevData => (isLoadMore ? [...prevData, ...result] : result))
      if (result?.length === prevDataLength && result?.length !== 0) {
        setHasMore(false)
      } else {
        setPrevDataLength(result?.length)
      }
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (id) {
      fetchData()
    }
  }, [id, filter])

  const loadMore = () => {
    if (!hasMore) return
    setFilter(prevFilter => ({
      ...prevFilter,
      limit: prevFilter.limit + 3,
    }))
  }

  const refetch = () => {
    setHasMore(true)
    setFilter({ limit: CommonConstant.defaultPageSize, page: 0 })
    fetchData()
  }

  return {
    data,
    setData,
    loading,
    error,
    filter,
    loadMore,
    refetch,
    hasMore,
  }
}
